let defaults = {
	colors: {
		very_low: '#dddddd',
		low: '#b44343',
		medium: '#efc550',
		high: '#7dc168',
	},
};

let passwordStrength = (input, options) => {
	options = Object.assign({}, defaults, options);

	if (input) {
		let meter = document.createElement('div');
		meter.id = 'password-strength-meter';
		meter.setAttribute('aria-live', true);
		meter.setAttribute('aria-atomic', true);
		meter.style.height = '4px';
		meter.style.width = '100%';
		meter.style.borderRadius = '2px';
		meter.style.position = 'relative';
		meter.style.top = '10px';

		let desc = document.createElement('span');
		desc.className = 'offscreen';

		meter.appendChild(desc);
		insertAfter(meter, input);

		options.target = meter;
		options.desc = desc;

		// KeyUp
		input.addEventListener('keyup', function (e) {
			validatePassword(e.target.value, options);
		});

		// On Load
		validatePassword(input.value, options);
	}
};
export default passwordStrength;

/**
 * Validate the Password
 * @param {*} password
 * @param {*} options
 */
let validatePassword = (password, options) => {
	let target = options.target;
	let desc = options.desc ? options.desc : '';

	// Do not show anything when the length of password is zero.
	if (password.length === 0) {
		desc.innerHTML = '';
		return;
	}
	// Create an array and push all possible values that you want in password
	let matchedCase = new Array();
	matchedCase.push('[$@$!%*#?&]'); // Special Charector
	matchedCase.push('[A-Z]'); // Uppercase Alpabetes
	matchedCase.push('[0-9]'); // Numbers
	matchedCase.push('[a-z]'); // Lowercase Alphabetes
	matchedCase.push('[A-Z0-9a-z$@$!%*#?&-_]{8}'); // Lowercase Alphabetes

	// Check the conditions
	let ctr = 0;
	for (let i = 0; i < matchedCase.length; i++) {
		if (new RegExp(matchedCase[i]).test(password)) {
			ctr++;
		}
	}

	// Display it
	let color = '';
	let strength = '';
	switch (ctr) {
		case 0:
		case 1:
		case 2:
		case 2:
			strength = 'Very Weak';
			color = options.colors.very_low;
			break;
		case 3:
			strength = 'Weak';
			color = options.colors.low;
			break;
		case 4:
			strength = 'Medium';
			color = options.colors.medium;
			break;
		case 5:
			strength = 'Strong';
			color = options.colors.high;
			break;
	}
	desc.innerHTML = strength;
	target.style.backgroundColor = color;
};

/**
 * Insert Element After
 * @param {*} el
 * @param {*} referenceNode
 */
let insertAfter = (el, referenceNode) => {
	referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
};
